import Vue from 'vue'
import storejs from 'store'

function saveMarked(marked) {
  storejs.set('mark:marked', marked)
}

const state = {
  marked: storejs.get('mark:marked') || {}, // mark marked item
}

const getters = {}

const mutations = {
  setMarked(state, tarUrl) {
    Vue.set(state.marked, tarUrl, 'marked')
    saveMarked(state.marked)
  },
  setUnmarked(state, tarUrl) {
    Vue.set(state.marked, tarUrl, '')
    saveMarked(state.marked)
  },
}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
